import Button from 'components/Form/Button'
import ContainerUnauthenticated from 'containers/Unauthenticated'
import React from 'react'
import { Icon } from 'ui/styled'
import { FormTitle, SuccessText, UnauthenticatedContainer } from './styled'
import useI18n from 'hooks/useI18n'

export default function FormSuccess({ success, quite, noHeader, actionLabel }) {
  const { t } = useI18n()
  return (
    <>
      <ContainerUnauthenticated success lightBlue header={!quite} login={!quite} noHeader={noHeader}>
        <UnauthenticatedContainer>
          <Icon icon="success" width={76} height={76} nomargin />
          <FormTitle>{success?.title}</FormTitle>
          <SuccessText>{success?.text}</SuccessText>
          <Button color="blue" nospace width="100%" onClick={success?.action}>{actionLabel || t('close')}</Button>
        </UnauthenticatedContainer>
      </ContainerUnauthenticated>
    </>
  )
}
